<div class="assessment-container">
  <h2>Respiratory Pattern</h2>
  <assessment-row title="Regular Rhythm" [historyMode]="true">
    <p>{{ isRegularRhythm }}</p>
  </assessment-row>

  @if (patient().isPediatric()) {
  <assessment-row title="Retractions Present" [historyMode]="true">
    <p>{{ isRetractionsPresent }}</p>
  </assessment-row>
  }

  <assessment-row title="Quality" [historyMode]="true">
    <p>{{ data().quality }}</p>
  </assessment-row>

  <h2>Lung Sounds</h2>
  <assessment-row title="RUL" [historyMode]="true">
    <p>{{ data().lungSoundsRul }}</p>
  </assessment-row>
  <assessment-row title="RLL" [historyMode]="true">
    <p>{{ data().lungSoundsRll }}</p>
  </assessment-row>
  <assessment-row title="RML" [historyMode]="true">
    <p>{{ data().lungSoundsRml }}</p>
  </assessment-row>
  <assessment-row title="LUL" [historyMode]="true">
    <p>{{ data().lungSoundsLul }}</p>
  </assessment-row>
  <assessment-row title="LLL" [historyMode]="true">
    <p>{{ data().lungSoundsLll }}</p>
  </assessment-row>

  <h2>Breathing</h2>
  <assessment-row title="Increased work of Breathing" [historyMode]="true">
    <p>{{ data().increasedWorkOfBreathing }}</p>
  </assessment-row>

  <h2>Cough</h2>
  <assessment-row title="Cough Present" [historyMode]="true">
    <p>{{ isCoughPresent }}</p>
  </assessment-row>

  @if (data().cough) {
  <assessment-row title="Description of Cough" [historyMode]="true">
    <p>{{ data().coughDescription }}</p>
  </assessment-row>

  @if (isProductiveCough) {
  <assessment-row title="Productive Description" [historyMode]="true">
    <emr-list [list]="data().productiveDescription" emptyText="N/A"></emr-list>
  </assessment-row>
  }
  }

  <h2>Trach</h2>
  <assessment-row title="Is Trach Present?" [historyMode]="true">
    <p>{{ isTrachPresent }}</p>
  </assessment-row>

  @if (data().trachPresent) {
  <assessment-row title="Trach Size" [historyMode]="true">
    <p>{{ data().trachSize }}</p>
  </assessment-row>
  }

  <assessment-row title="Other Findings" [historyMode]="true">
    <p>{{ data().otherFindings }}</p>
  </assessment-row>
</div>